import React, { useCallback, useEffect, useState } from "react";

// assets
import { images } from "assets/images/index";
import { ICONS } from "assets/icons";
import WhatsAppWithBg from "../../../assets/customSVG/WhatsAppWithBg";
import CreateWABAError from "components/commonComponents/createWABALoader/CreateWABAError";

// utils
import { useNavigate } from "react-router-dom";
import { Skeleton, Modal, Button } from "antd";
import WhatsAppConnectionModal from "../../channels/page/whatsapp/components/WhatsAppConnectionModal";
import Loader from "../../../components/commonComponents/Loader/Index"
import WhatsAppNumberSelect from "components/WhatsAppNumberSelect";
import moment from "moment";

// API
import { createWABA, retryCreateWABA } from "api/apiClients/meta/whatsapp";
import { currentUserDetails } from "../../../api/Api";
import {
  campaignList,
  conversationPerformanceApi,
  conversationSummaryApi,
} from "../api/Api";
import { broadcastList } from "../../../api/apiClients/broadcast";
import { whatsappBusinessNumbers } from "../api/Api";

// hooks
import useToggle from "hooks/useToggle";

// helpers
import { capitalizeFirstLetter } from "helper/capitalizeFirstLetter";
import { useWeekCalender } from "hooks/calenders/useWeekCalender";

// redux
import { useAspDispatch, useAspSelector } from "../../../test/jest-redux-hooks";
import {
  setBrandUserRoles,
  updateCurrentBrand,
  updateCurrentUser,
} from "../../../reduxToolkit/appSlice";

// components
import NoData from "components/commonComponents/Nodata/index";
import BroadcastListCard from "../components/BroadcastListCard";
import Calender from "../components/Calender";
// import ConversationOverview from "../components/ConversationOverview";
import WhatAppBusiness from "../components/WhatAppBusiness";
import Chart from "../components/Chart";
import ConversationSummary from "../components/ConversationSummary";
import Notifications from "../components/Notifications";
import { aboutCardsList } from "../constants";
import { setupApi, getBrandModeDetails } from "../../accounts/api/Api";
import { configId, solutionID } from "../../../api/ApiConfig";
import FilterHome from "../../../components/commonComponents/filterHome/FilterHome";
import { HomeFilterCampaign } from "../../../constant/app/Filter/Filter";
import CreateWABALoader from "../../../components/commonComponents/createWABALoader";

const Home = () => {
  // router
  const navigate = useNavigate();

  // redux
  const { currentBrand, currentAccount, currentUser } = useAspSelector(
    (state) => state?.app
  );
  const dispatch = useAspDispatch();
  const [loaders, setLoader] = useState(false);

  // calender
  const {
    selectedDate,
    weeks,
    next,
    prev,
    onChange: onSelect,
    resetToToday,
  } = useWeekCalender();

  // summary
  const [conversationSummary, setConversationSummary] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [campaignCount, setCampaignCount] = useState(3);
  const [campaignPerformanceList, setCampaignPerformanceList] = useState([]);

  // broadcast
  const [isBroadcast, setIsBroadcast] = useToggle(false);
  const [broadcast, setBroadcast] = useState([]);

  // create WABA
  const [sessionData, setSessionData] = useState(null);
  const [data, setData] = useState(null);
  const [isRes, setIsRes] = useState(false);
  const [brandModeDetails, setBrandModeDetails] = useState(null);
  const [isResError, setIsResError] = useState({
    error: false,
    data: "",
  });
  const [res, setRes] = useState(null);
  const [setupData, setSetupData] = useState([]);
  const [whatsappNumbers, setWhatsappNumbers] = useState([]);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [loadingNumbers, setLoadingNumbers] = useState(false);
  const [isSelectionModalOpen, setIsSelectionModalOpen] = useState(false);
  const [connectionType, setConnectionType] = useState(null);

  const today = moment();

  //----------------------setup---------------------
  // Fetch WhatsApp business numbers
  const fetchWhatsappNumbers = useCallback(async () => {
    if (!currentBrand?.brand_id) return;
    
    setLoadingNumbers(true);
    try {
      const res = await whatsappBusinessNumbers(currentBrand.brand_id, {
        brand_id: currentBrand.brand_id,
        call_meta: 'false',
      });
      
      if (res?.data?.wapp_business_num?.length > 0) {
        setWhatsappNumbers(res.data.wapp_business_num);
        // Set the first number as default selected
        setSelectedNumber(res.data.wapp_business_num[0]);
      }
    } catch (error) {
      console.error('Error fetching WhatsApp numbers:', error);
    } finally {
      setLoadingNumbers(false);
    }
  }, [currentBrand?.brand_id]);

  useEffect(() => {
    setupApi(currentBrand?.brand_id).then((res) => {
      if (res?.status === 200) {
        setSetupData(res?.data);
      }
    });
    
    fetchWhatsappNumbers();
  }, [currentBrand, fetchWhatsappNumbers]);

  //----------------------calendar----------------------
  const initialStartDate = today
    .clone()
    .subtract(6, "days")
    .format("YYYY-MM-DD");
  const initialEndDate = today.format("YYYY-MM-DD");

  useEffect(() => {
    setStartDate(initialStartDate);
    setEndDate(initialEndDate);
  }, [initialStartDate, initialEndDate]);

  useEffect(() => {
    if (selectedDate)
      getBroadCastList(
        currentBrand?.brand_id,
        moment(selectedDate).format("DD-MM-YYYY"),
        moment(selectedDate).format("DD-MM-YYYY")
      );
  }, [currentBrand, selectedDate]);

  const getBroadCastList = async (brandId, startDate, enddate) => {
    if (brandId && startDate && enddate) {
      setIsBroadcast(true);
      setBroadcast([]);
      try {
        const res = await broadcastList(brandId, startDate, enddate);
        if (res?.data?.broadcasts?.length > 0) {
          const filter = res?.data?.broadcasts?.filter(
            (c) => ![0, 12].includes(c.status)
          );
          setBroadcast(filter);
        } else {
          setBroadcast([]);
        }
      } catch (e) {
        console.warn(e);
      } finally {
        setIsBroadcast(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("message", sessionInfoListener);

    return () => {
      window.removeEventListener("message", sessionInfoListener);
    };
  }, []);

  // Generate dummy data for test mode
  const generateDummyData = (count) => {
    const dummyCampaigns = [];
    for (let i = 1; i <= count; i++) {
      const sent = Math.floor(Math.random() * 1000) + 100;
      const delivered = Math.floor(sent * (0.9 + Math.random() * 0.09)); // 90-99% of sent
      const opened = Math.floor(delivered * (0.7 + Math.random() * 0.25)); // 70-95% of delivered
      const bounced = Math.floor(sent * (0.01 + Math.random() * 0.04)); // 1-5% of sent
      
      dummyCampaigns.push({
        id: 300 + i,
        campaign_name: `Campaign ${i}`,
        sent_count: sent,
        delivered_count: delivered,
        opened_count: opened,
        bounced_count: bounced
      });
    }
    return dummyCampaigns;
  };

  //--------------------------conversation performance--------------------
  useEffect(() => {
    setLoader(true);
    
    // Check if we're in test mode
    if (currentBrand?.brand_mode === 'test') {
      // Generate dummy data for test mode
      setTimeout(() => {
        const dummyData = generateDummyData(campaignCount || 3);
        setCampaignPerformanceList(dummyData);
        setLoader(false);
      }, 500); // Simulate network delay
    } else {
      // Normal API call for non-test mode
      const payLoad = {
        brand_id: currentBrand?.brand_id,
        recent_campaign_count: campaignCount,
      };

      conversationPerformanceApi(payLoad).then((res) => {
        if (res?.data?.length > 0) {
          setCampaignPerformanceList(res?.data);
        }
        setLoader(false);
      }).catch(() => {
        setLoader(false);
      });
    }
  }, [campaignCount, currentBrand]);

  const fetchApiByFilter = useCallback(
    (filter) => {
      let newStartDate, newEndDate;

      newEndDate = today.format("YYYY-MM-DD");

      switch (filter) {
        case "Last 7 days":
          newStartDate = today.clone().subtract(6, "days").format("YYYY-MM-DD");
          break;
        case "This Month":
          newStartDate = today.clone().startOf("month").format("YYYY-MM-DD");
          break;
        case "This Year":
          newStartDate = today.clone().startOf("year").format("YYYY-MM-DD");
          break;
        default:
          newStartDate = today
            .clone()
            .subtract(30, "days")
            .format("YYYY-MM-DD");
      }

      setStartDate(newStartDate);
      setEndDate(newEndDate);
    },
    [startDate, endDate]
  );

  useEffect(() => {
    if (sessionData && data) {
      const payload = {
        brand_id: currentBrand?.brand_id,
        waba_id: sessionData?.waba_id,
        phone_number_id: sessionData?.phone_number_id,
        code: data?.authResponse?.code,
        connection_type: connectionType === 'bsp' ? 'bsp' : 'meta'
      };
      createWhatsappAccount(payload);
    }
  }, [data, sessionData]);

  const handleFilterChange = (filter) => {
    let recent_campaign_count;

    switch (filter) {
      case "Last 3 Campaigns":
        recent_campaign_count = 3;
        break;
      case "Last 5 Campaigns":
        recent_campaign_count = 5;
        break;
      case "Last 7 Campaigns":
        recent_campaign_count = 7;
        break;
      case "Last 10 Campaigns":
        recent_campaign_count = 10;
        break;

      default:
        recent_campaign_count = 3;
    }

    setCampaignCount(recent_campaign_count);
  };
  //-----------------------conversation summary-----------------------
  useEffect(() => {
    if ((startDate, endDate)) {
      const payLoad = {
        brand_id: currentBrand?.brand_id,
        start_date: startDate,
        end_date: endDate,
      };
      conversationSummaryApi(payLoad).then((res) => {
        if (res?.status === 200) {
          setConversationSummary(res?.data);
        }
      });
    }
  }, [currentBrand, startDate, endDate]);

  const sessionInfoListener = (event) => {
    if (
      event.origin !== "https://www.facebook.com" &&
      event.origin !== "https://web.facebook.com"
    ) {
      return;
    }
    try {
      const data = JSON.parse(event.data);
      if (data.type === "WA_EMBEDDED_SIGNUP") {
        if (data.event === "FINISH") {
          const { phone_number_id, waba_id } = data.data;
          setSessionData(data?.data);
        } else if (data.event === 'CANCEL') {
          const { current_step } = data.data;
          console.warn('Cancel at', current_step);
        }
        else if (data.event === 'ERROR') {
          const { error_message } = data.data;
          console.error('Error', error_message);
        }
      }
    } catch {
      console.warn("Non JSON Response", event.data);
    }
  };

  // connecting the webhook
  const createWhatsappAccount = async (payload) => {
    setIsRes(true);
    try {
      const res = await createWABA(payload);
      setRes(res?.data);
      if (res?.status === 200) {
        await fetchCurrentUserDetails();
        setIsRes(false);
        // setIsResError(false);
      } else {
        const data = {
          error: true,
          data: res?.response?.data?.error,
        };
        setIsResError(data);
      }
    } catch (e) {
      console.warn(e);
      setRes(null);
    }
  };

  const retryWABACreate = async () => {
    setIsRes(true);
    setIsResError({
      error: false,
      data: "",
    });
    try {
      const res = await retryCreateWABA({
        brand_id: currentBrand?.brand_id,
        connection_type: connectionType === 'bsp' ? 'bsp' : 'meta'
      });
      if (res.status === 200) {
        const newRes = await fetchCurrentUserDetails();
        if (newRes?.status === 200) {
          window.location.reload();
          setIsRes(false);
        }
        await fetchCurrentUserDetails();
        setIsRes(false);
      } else {
        setIsResError({
          error: true,
          data: res?.response?.data?.error,
        });
      }
    } catch (e) {
      console.warn(e);
    }
  };

  const fetchCurrentUserDetails = async () => {
    try {
      const res = await currentUserDetails();
      dispatch(updateCurrentUser(res?.data));
      dispatch(setBrandUserRoles(res?.data));
      const checkBrandExist = res?.data?.active_accounts?.find(
        (a) => a?.account_id === currentAccount?.account_id
      )?.brands?.filter(
        (b) =>
          b?.brand_id === currentBrand?.brand_id &&
          b?.is_whatsapp_connected !== currentBrand?.is_whatsapp_connected
      );

      setIsRes(false);
      if (checkBrandExist?.length > 0) {
        dispatch(updateCurrentBrand(checkBrandExist?.[0]));
        dispatch(updateCurrentUser(res?.data));
      } else {
        dispatch(
          updateCurrentBrand(res?.data?.active_accounts?.[0]?.brands?.[0])
        );
      }
    } catch (error) {
      setIsRes(false);
      console.warn("Error fetching current user details:", error);
    }
  };

  // launch the meta embedded signup window
  async function launchWhatsAppSignup() {
    setIsSelectionModalOpen(true);
  };

  async function handleWhatsAppSignup(type) {
    let data = null;
    setConnectionType(type);
    setIsSelectionModalOpen(false);
    await FB.login(
      function (response) {
        if (response.authResponse) {
          const code = response.authResponse.code;
          setData(response);
        } else {
          console.warn("User cancelled login or did not fully authorize.");
        }
      },
      {
        config_id: configId,
        response_type: "code",
        override_default_response_type: true,
        extras: {
          sessionInfoVersion: 3,
          version: "v3",
          setup: type === 'bsp' ? { solutionID: solutionID } : {},
          features: [
            {
              name: "marketing_messages_lite"
            }
          ]
        }
      }
    );

    return data;
  };

  // Fetch brand mode details when brand_mode is 'test'
  useEffect(() => {
    const fetchBrandModeDetails = async () => {
      if (currentBrand?.brand_mode === 'test' && currentBrand?.brand_id) {
        try {
          const data = await getBrandModeDetails(currentBrand.brand_id);
          setBrandModeDetails(data);
        } catch (error) {
          console.error('Error fetching brand mode details:', error);
        }
      }
    };

    fetchBrandModeDetails();
  }, [currentBrand?.brand_mode, currentBrand?.brand_id]);

  // Calculate remaining days for test account
  const calculateRemainingDays = (createdAt) => {
    if (!createdAt) return 0;
    const createdDate = new Date(createdAt);
    const expiryDate = new Date(createdDate);
    expiryDate.setDate(expiryDate.getDate() + 7); // Add 7 days to created date
    const today = new Date();
    const diffTime = expiryDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  const handleNavigate = (data) => {
    window.open(data?.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="w-full h-full">
      <div
        className={`w-full h-full bg-[#f9f9fc] relative ${
          isRes ? "opacity-[16%] blur-sm" : "opacity-100"
        }`}
      >
        {!currentBrand?.is_whatsapp_connected && (
          <Notifications launchWhatsAppSignup={launchWhatsAppSignup} />
        )}

        <div
          className={`w-[92%] m-auto h-full flex pt-[4%] gap-x-[2.5vw] gap-y-[1vw] overflow-hidden overflow-y-scroll`}
        >
          <div className="w-full h-full flex flex-col justify-between gap-x-[1.5vw] gap-y-[1.5vw]">
            <div className="flex w-full  pb-[1.5vw] justify-between object-cover border-b-[1px] border-[var(--border-input)]">
              <div className="">
                <h1 className="text-[var(--textBlack)] mb-[0.3vw] font28px-500 flex-row items-center">
                  Hello,
                  {(currentUser?.first_name || currentUser?.last_name) && (
                    <div className="bg-[#DCF5E9] py-1 px-2 rounded-lg ml-3 flex items-center">
                      <>
                      {currentUser?.first_name
                        ? capitalizeFirstLetter(currentUser?.first_name)
                        : ""}
                      {currentUser?.last_name
                        ? currentUser?.first_name
                          ? ` ${capitalizeFirstLetter(currentUser?.last_name)}`
                          : capitalizeFirstLetter(currentUser?.last_name)
                        : ""}
                    </>
                    <img
                      src={ICONS?.heartEyeEmoji}
                      alt="heartEyeEmoji"
                      className="pl-3"
                    />
                    </div>
                  )}
                </h1>
                <p className="text-[#616874] font16px-400">
                  Welcome to GainWix.ai! Let's get started,{" "}
                  {currentBrand?.brand_name}.
                </p>
              </div>

              {currentBrand?.brand_mode === "test" && brandModeDetails && (
                <div className="bg-white rounded-lg p-2 w-[fit-content] h-[fit-content] max-w-sm items-center">
                  <div className="flex flex-col gap-1 items-center">
                    <div className="flex items-center">
                      <h4 className="text-[var(--textBlack)] text-sm font-semibold">Test Account Connected : (+{brandModeDetails?.country_code}) {brandModeDetails?.phone_number}</h4>
                    </div>
                    <div className="flex items-center">
                      <span className={`inline-block w-2 h-2 rounded-full mr-1 ${calculateRemainingDays(brandModeDetails.created_at) > 0 ? 'bg-green-500' : 'bg-red-500'}`}></span>
                      <span className="text-sm font-normal">
                        {calculateRemainingDays(brandModeDetails.created_at) > 0 ? (
                          `Active (Expires in ${calculateRemainingDays(brandModeDetails.created_at)} days)`
                            ) : (
                              <span className="text-[#FF543E]">Expired</span>
                            )}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex flex-row justify-between gap-x-[1.1vw] gap-y-[1.5vw]  overflow-hidden flex-1 pb-[15px]">
              <div className="w-[73%] h-full max-h-[100%] flex flex-col gap-y-4 pr-[0.5vw] overflow-hidden overflow-y-scroll">
                {/* Brand Setup Section */}
                <WhatAppBusiness
                  setupData={setupData}
                  launchWhatsAppSignup={launchWhatsAppSignup}
                />
                {/* Campaign Performance Section */}
                <div className="bg-white rounded-[1vw] px-[2vw] py-[1vw] w-100">
                  <div className="flex-row justify-between items-center pb-4">
                    <p className="flex-row items-center font18px-500 text-[var(--textBlack)]">
                      Campaign Performance
                      <div
                        className="ml-2 pointer"
                        onClick={() => navigate("/user/campaign/all-campaigns")}
                      >
                        <img
                          src={ICONS?.homeDownload}
                          className="w-[18px] h-[18px]"
                        />
                      </div>
                    </p>

                    {!loaders && (
                      <FilterHome
                        filterList={HomeFilterCampaign}
                        fetchApiByFilter={handleFilterChange}
                      />
                    )}
                  </div>
                  {loaders ? (
                    <div
                      className="flex justify-center items-center"
                      style={{ height: "34vh" }}
                    >
                      <div class="loader flex-row align-center"></div>
                    </div>
                  ) : (
                    <Chart
                      campaignPerformanceList={campaignPerformanceList}
                      setCampaignCount={setCampaignCount}
                      loaders={loaders}
                    />
                  )}
                </div>

                {/* Conversation Summary Section */}
                <ConversationSummary
                  conversationSummary={conversationSummary}
                  fetchApiByFilter={fetchApiByFilter}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                />
                {/* <ConversationSource /> */}

                <div className="flex-row items-center font18px-500 text-[var(--textBlack)] py-3">
                  Get to know more about GainWix.ai
                </div>
                <div className="w-100 flex gap-[1vw]">
                  {aboutCardsList?.map((data) => (
                    <div
                      key={data?.id}
                      className="bg-white w-[22vw] p-2 rounded-xl"
                      // style={{
                      //   backgroundImage: `url(${ICONS?.homeWhatsapp})`,
                      // }}
                    >
                      <div
                        className="bg-cover w-full h-[18vh] rounded-xl p-3 flex flex-col items-start  justify-between "
                        style={{
                          backgroundImage: `url(${data?.image})`,
                        }}
                      >
                        <div className="flex">
                          {data?.id === 1 && (
                            <div>
                              <img
                                src={ICONS?.homeBlog}
                                className="pr-3 pt-1"
                              />
                            </div>
                          )}
                          <div className="pt-1.5 w-100">
                            <p className="font16px-600 text-[var(--textBlack)]">
                              {data?.title}
                            </p>
                            <p
                              className={`font14px-400 ${
                                data?.id !== 1
                                  ? "text-[#E7F4FC] w-70"
                                  : "text-[var(--font-600)]"
                              }`}
                            >
                              {data?.content}
                            </p>
                          </div>
                        </div>

                        <button
                          className="flex items-center justify-end bg-[#E8E1FF] rounded-lg py-1.5 px-2.5 font16px-400 pt-5 mt-5 text-violet-700 gap-1"
                          onClick={() => handleNavigate(data)}
                        >
                          {data?.button}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* <AboutCardsContainer /> */}

              <div className="w-[27%] h-[100%] flex flex-col justify-between gap-x-[1.5vw] gap-y-[0.5vw]">
                <div className="w-full bg-white rounded-[1vw] py-[0.5vw] flex flex-col flex-1">
                  <div className="px-[0.8vw] pt-[0.3vw]">
                    <Calender
                      selectedDate={selectedDate}
                      weeks={weeks}
                      next={next}
                      prev={prev}
                      onSelect={onSelect}
                      resetToToday={resetToToday}
                    />
                  </div>
                  <div className="mt-[0.8vw] w-full min-h-[25vh] flex flex-col flex-1 items-center justify-center  overflow-hidden pl-[1vw] pr-[0.5vw]">
                    <Skeleton
                      rootClassName="pr-[0.5vw]"
                      loading={isBroadcast}
                      paragraph={{ rows: 4 }}
                      active
                    >
                      {broadcast?.length > 0 ? (
                        <div className="w-full h-full flex flex-col justify-between">
                          <div className="w-full min-h-[25vh] max-h-[25vh] gap-y-[0.5vw] pr-[0.5vw] overflow-y-scroll listScroll">
                            {broadcast?.map((list) => {
                              return <BroadcastListCard broadcast={list} />;
                            })}
                          </div>
                          <div className="w-full flex items-center justify-center">
                            <button
                              className="w-auto py-[6px] font16px-500 text-[#6940F2] flex items-center justify-center gap-[0.5vw]"
                              onClick={() => {
                                navigate("/user/calendar");
                              }}
                            >
                              <img
                                src={ICONS?.viewCalendar}
                                alt="calender icon"
                                className="w-[1.2vw] h-[1.2vw]"
                              />
                              <p>View Calender</p>
                            </button>
                          </div>
                        </div>
                      ) : (
                        <NoData
                          icon={images?.NoData}
                          title={"No broadcast have been found."}
                          titleClassName="font-md weighit-medium"
                        />
                      )}
                    </Skeleton>
                  </div>
                </div>

                <div className="w-full min-h-[23vh] flex flex-col gap-2 px-4 py-2 bg-white rounded-lg">
                  <div className="w-full font-bold text-sm text-gray-700">WhatsApp Business Number</div>
                  {loadingNumbers ? (
                    <div className="min-w-[18vw] h-full h-8 flex items-center justify-center">
                      <Loader Width="24px" Height="24px" />
                    </div>
                  ) : whatsappNumbers.length > 0 ? (
                    <WhatsAppNumberSelect 
                      numbers={whatsappNumbers}
                      selectedNumber={selectedNumber}
                      onSelect={setSelectedNumber}
                      loading={loadingNumbers}
                    />
                  ) : (
                    <div className="text-gray-500 text-center h-full flex items-center justify-center">No WhatsApp business numbers found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isRes ? (
        <div
          className={`w-full h-full absolute top-0 left-0 flex flex-col items-center justify-center `}
        >
          {isResError?.error ? (
            <>
              <CreateWABAError width={"11vw"} height={"6vw"} />
              <p
                className={`font-large weight-semibold mt-6 ${
                  ["payment", "two-factor"]?.includes(isResError?.data)
                    ? "text-[var(--primary)]"
                    : "text-[#F96056]"
                }`}
              >
                {isResError?.data === "payment"
                  ? 'Please configure the payment method and click "continue".'
                  : isResError?.data === "two-factor"
                  ? "Enable your 2-factor authentication in your WhatsApp manager and click continue."
                  : "Unexpected error happen, please retry!"}
              </p>
              <button
                className={`font-md weight-medium text-[#F96056] font-normal weight-bold px-[0.85vw] py-[0.4vw] rounded-[0.6vw] mt-[0.8vw] ${
                  ["payment", "two-factor"]?.includes(isResError?.data)
                    ? "bg-[var(--primary)] text-white"
                    : "bg-red-500 text-white"
                }`}
                onClick={() => {
                  retryWABACreate();
                }}
              >
                {["payment", "two-factor"]?.includes(isResError?.data)
                  ? "Continue"
                  : "Retry"}
              </button>
            </>
          ) : (
            <>
              <CreateWABALoader width={"11vw"} height={"6vw"} />
              <p className="font-large weight-semibold bg-gradient-to-r from-[#0ACD95] to-[#6940F2] bg-clip-text text-transparent">
                Hold on, we&apos;re setting up things for you.
              </p>
            </>
          )}
        </div>
      ) : (
        <></>
      )}

      <WhatsAppConnectionModal
        open={isSelectionModalOpen}
        onCancel={() => setIsSelectionModalOpen(false)}
        onSelect={handleWhatsAppSignup}
      />
    </div>
  );
};

export default Home;
